import { Session } from 'smg/customer-api/session';
import { CategoryDescriptionsFromDocument, InitEmailPreferencesPanel } from 'smg/email-preferences-page';
import { InitSmsPreferencesPanel } from 'smg/sms-preferences-panel';

import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }
    // The panels own their own loading, failed and retry states, so they
    // start first; the session only decorates them (the account the settings
    // belong to, the number the texts go to) and a failed read leaves the
    // panels usable with those two lines blank.
    InitEmailPreferencesPanel({ mode: 'session', categoryDescriptions: CategoryDescriptionsFromDocument() });
    const smsPanel = InitSmsPreferencesPanel({
        mode: 'session',
        categoryDescriptions: CategoryDescriptionsFromDocument('#sprefs-categories'),
    });
    const $email = document.querySelector('#notif-email') as HTMLElement;
    void Session().then(sess => {
        $email.textContent = sess.user.emailAddress.email ?? '';
        smsPanel.setPhone(sess.user.phoneNumber.phone ?? '');
    }).catch(() => undefined);
}
